import { Link } from 'react-router-dom';
import { categories, rankings } from '@/mocks/home';

export default function CategoryRankSection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
          <div>
            <div className="mb-8">
              <p className="text-sm text-foreground-500 font-medium tracking-wider uppercase mb-3">
                分类浏览
              </p>
              <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-950 leading-tight">
                探索你喜欢的类型
              </h2>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to="/category/all"
                  className="bg-background-100 rounded-2xl p-4 text-center hover:bg-accent-50 transition-colors cursor-pointer group"
                >
                  <div className="w-10 h-10 mx-auto mb-2 rounded-xl bg-accent-100 group-hover:bg-accent-200 flex items-center justify-center transition-colors">
                    <i className={`${cat.icon} text-lg text-accent-500`}></i>
                  </div>
                  <p className="text-sm font-medium text-foreground-800 mb-0.5">{cat.name}</p>
                  <p className="text-xs text-foreground-500">{cat.count}部</p>
                </Link>
              ))}
            </div>
          </div>

          <div>
            <div className="mb-8">
              <p className="text-sm text-foreground-500 font-medium tracking-wider uppercase mb-3">
                人气排行
              </p>
              <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-950 leading-tight">
                本周热门排行榜
              </h2>
            </div>
            <div className="bg-background-100 rounded-2xl p-4 md:p-6">
              {rankings.map((item) => (
                <Link
                  key={item.rank}
                  to={`/comic/comic-${item.rank}`}
                  className="flex items-center gap-4 py-3 px-3 rounded-xl hover:bg-background-50 transition-colors cursor-pointer group"
                >
                  <span className={`w-7 h-7 rounded-lg flex items-center justify-center text-xs font-bold ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-600'
                  }`}>
                    {item.rank}
                  </span>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
                      {item.title}
                    </p>
                  </div>
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {item.views}
                    </span>
                    <span>{item.rating}</span>
                    <i className={`${
                      item.trend === 'up'
                        ? 'ri-arrow-up-line text-accent-500'
                        : item.trend === 'down'
                        ? 'ri-arrow-down-line text-red-400'
                        : 'ri-subtract-line text-foreground-400'
                    }`}></i>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}